import cliente from './AxiosCliente'; 

const url = 'controller/galeria.php'; 

export default class {

    mostrar = () => {
        let formData = new FormData();
        formData.append('funcion', 'mostrar')  
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    ingresar = (nombre, files) => {
        let formData = new FormData();
        formData.append('funcion', 'ingresar');
        formData.append('nombre', nombre);
        for (let i = 0 ; i < files.length ; i++) {
            formData.append("file[]", files[i].file);
        }
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    imagenes = (id) => {
        let formData = new FormData();
        formData.append('funcion', 'imagenes');
        formData.append('id', id);
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    editar = (id, nombre, files) => {
        let formData = new FormData();
        formData.append('funcion', 'editar');
        formData.append('id', id);
        formData.append('nombre', nombre);
        for (let i = 0 ; i < files.length ; i++) {
            formData.append("file[]", files[i].file);
        }
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    eliminar = (id) => {
        let formData = new FormData();
        formData.append('funcion', 'eliminar');
        formData.append('id', id);
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    eliminarImagen = (id) => {
        let formData = new FormData();
        formData.append('funcion', 'eliminarImagen');
        formData.append('id', id);
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }
    
    editarBlog = (id) => {
        let formData = new FormData();
        formData.append('funcion', 'editarGaleria');
        formData.append('galeria_id', id);
        let consulta =  cliente.post({url: 'controller/blog.php', data: formData})
        return consulta;
    }

    getBlogs = (id) => {
        let formData = new FormData();
        formData.append('funcion', 'getBlogs');
        formData.append('galeria_id', id);
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }
    eliminarEnBlog = (blogs) => {
        let formData = new FormData();
        formData.append('funcion', 'eliminarGaleria');
        formData.append('blogs', JSON.stringify(blogs));
        let consulta =  cliente.post({url: 'controller/blog.php', data: formData})
        return consulta;
    }


}